(function () {
  const mq = window.matchMedia('(min-width: 990px)');
  if (!mq.matches) return;

  const state = {
    t: null,
    lastMediaId: null
  };

  function getFeaturedMediaIdFromEvent(e) {
    // Selon les thèmes/apps, l’info peut être à plusieurs endroits
    const v =
      e?.detail?.variant ||
      e?.detail?.product?.selectedVariant ||
      e?.detail?.selectedVariant ||
      null;

    const fm = v?.featured_media || v?.featuredMedia || null;
    return fm?.id || fm?.media_id || null;
  }

  function findGallery() {
    // Prestige: <product-gallery> souvent présent
    return document.querySelector('product-gallery') || document.querySelector('.product-gallery');
  }

  function findMediaElement(gallery, mediaId) {
    if (!gallery || !mediaId) return null;

    // On tente plusieurs formats possibles
    const selectors = [
      `[data-media-id="${mediaId}"]`,
      `[data-media-id="gid://shopify/MediaImage/${mediaId}"]`,
      `[data-media-id="gid://shopify/Video/${mediaId}"]`,
      `[data-media-id*="/${mediaId}"]`
    ];

    for (const sel of selectors) {
      const el = gallery.querySelector(sel);
      if (el) return el;
    }

    // Fallback : parfois l’élément actif est juste aria-current/selected
    return (
      gallery.querySelector('.product-gallery__media[aria-current="true"]') ||
      gallery.querySelector('.product-gallery__media[aria-selected="true"]') ||
      gallery.querySelector('.product-gallery__media.is-selected') ||
      null
    );
  }

  function scrollCarouselToMedia(gallery, mediaEl) {
    if (!gallery || !mediaEl) return;

    const carousel =
      gallery.querySelector('scroll-carousel.product-gallery__carousel') ||
      gallery.querySelector('.product-gallery__carousel');

    if (!carousel) return;

    // IMPORTANT: on scrolle le conteneur, pas le viewport
    const top = mediaEl.offsetTop - carousel.offsetTop;

    // Si déjà “quasi en place”, on ne touche pas (évite micro-jitter)
    if (Math.abs((carousel.scrollTop || 0) - top) < 2) return;

    carousel.scrollTo({ top, behavior: 'auto' });
  }

  function run(e) {
    clearTimeout(state.t);

    state.t = setTimeout(() => {
      const gallery = findGallery();
      if (!gallery) return;

      const mediaId = getFeaturedMediaIdFromEvent(e);

      // Si on a un mediaId et qu’il n’a pas changé, inutile de rescroller
      if (mediaId && mediaId === state.lastMediaId) return;
      if (mediaId) state.lastMediaId = mediaId;

      // On laisse Prestige finir son update DOM (2 frames = très stable)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const mediaEl = findMediaElement(gallery, mediaId);
          scrollCarouselToMedia(gallery, mediaEl);
        });
      });
    }, 60);
  }

  document.addEventListener('variant:change', run);
  document.addEventListener('variant:changed', run);

  // petit “alignement” au chargement
  window.addEventListener('load', () => run({}));
})();
